import { useCallback, useState } from 'react';
import createUseContext from 'constate';
import {
  getRedeemInfo as apiGetRedeemInfo,
} from '../api/redeemCode';
import { useAuthState } from '../../preorder/plugins/Auth';

const useRedeemInfoStore = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isInited, setIsInited] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [redeemCode, setRedeemCode] = useState({});
  const [productsDict, setProductsDict] = useState({});
  const { token } = useAuthState();

  const getRedeemInfo = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await apiGetRedeemInfo(token);
      const { status, data, message } = result || {};

      if (status !== 'success') throw new Error(message);

      const {
        productsDict: dataProductsDict,
        redeemCode: dataRedeemCode,
        vouchers: dataVouchers,
      } = data || {};

      setVouchers(dataVouchers);
      setRedeemCode(dataRedeemCode);
      setProductsDict(dataProductsDict);

      setIsInited(true);
    } catch (e) {
      // ignore the error
    }

    setIsLoading(false);
  }, [token]);

  return {
    getRedeemInfo,
    isInited,
    isLoading,
    productsDict,
    redeemCode,
    vouchers,
  };
};

const [RedeemInfoStoreProvider, useRedeemInfoStoreContext] = createUseContext(useRedeemInfoStore);

export {
  RedeemInfoStoreProvider,
  useRedeemInfoStoreContext,
};
